import { Deserializable } from './deserializable.model';
import { JsonObject } from './json-object.model';
import { Serializable } from './serializable.model';
import { RoleKey } from './tag.model';

export class TagRole implements Deserializable<any, TagRole>, Serializable<JsonObject> {
  constructor(public id?: string, public key?: RoleKey, public priority?: number) {}

  deserialize(input: any): TagRole {
    if (input == null) {
      return null;
    }
    this.id = input.id;
    this.key = input.tagRoleKey as RoleKey;
    this.priority = JSON.parse(input.tagRolePriority);
    return this;
  }

  serialize(): JsonObject {
    const json: JsonObject = {};
    json['id'] = this.id;
    json['tagRoleKey'] = this.key;
    json['tagRolePriority'] = this.priority;

    return json;
  }
}
